import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function BillingCancelPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-xl font-semibold">Checkout abgebrochen</h1>
      <p className="max-w-md text-sm text-muted-foreground">Es wurde nichts berechnet.</p>
      <Button asChild variant="outline"><Link to="/einstellungen/billing">Zurück zu Abrechnung</Link></Button>
    </main>
  )
}
